import { CSSProperties, FC } from "react";

const GraphContainerStyle: CSSProperties = {
  background: "#fff",
  boxShadow: "0px 0px 20px 7px rgba(0,0,0,0.1)",
};

const BoxContainer: FC<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = (props) => {
  const { children, ...otherProps } = props;
  return (
    <div style={GraphContainerStyle} {...otherProps}>
      {children}
    </div>
  );
};

export default BoxContainer;
